<template>
  <header class="lms-content-header pd-x-20" @click="closeLevel2()">
    <div v-show="showBackdrop" class="header-backdrop"></div>
    
    <div class="d-block d-lg-none">
      <a @click.stop="showLevel2()" class="pd-10" role="button">
        <img :src="`${myResBaseUrl}v4-assets/svgicon/menu/solid/menu-line-horizontal.svg`" class="ht-32 wd-32" />
      </a>      
    </div>
    <div class="d-block d-lg-none mg-l-10 hdr-logo">
    <router-link to="/">
      <div class="d-flex align-items-center head-branding">
        <div class="avatar avatar-sm mg-r-8">
          <img class="mg-r-10"
            v-if="!$store.state.app.skin.dark"
            :src="`${myResBaseUrl}${$store.state.app.activeGroup.logo}`"
            :style="`max-width: 60px; max-height: 50px`"
          />
        </div>
        <span class="tx-20 tx-color-01 tx-semibold d-none">{{$store.state.app.activeGroup.name}}</span>
      </div>

    </router-link>
    </div>

          
          <div class="d-none d-md-block mg-l-10 tx-20">
            {{ $store.state.app.activeGroup.name }}
            
          </div>
          <div class="d-flex mg-l-auto">
            <nav id="directNav" class="lmsNav">
              <header-bar-notification></header-bar-notification>
              <header-bar-localmail></header-bar-localmail>

              <div :class="`dropdown dropdown-profile`" v-show="$route.name!='lmsParticipant'">
                <a href class="dropdown-link" data-toggle="dropdown">

                  <vc-donut
        :sections="[
          {
            value:
              mustJoinCourses.all > 0
                ? (mustJoinCourses.finished * 100) / mustJoinCourses.all
                : 0,
            color: '#eb4872',
          },
        ]"
        class="avator-bg"
    
        background="#fafafa"
        foreground="#fff"
        :size="55"
        unit="px"
        :thickness="8"
        :total="100"
        :start-angle="-30"
        :auto-adjust-text-size="true"
      >
        <div class=" mg-y-20">
          <img
            :src="`${$store.state.user.userInfo.avator}`"
            class="rounded-circle wd-40 ht-40"
          />
        </div>
      </vc-donut>

                  <!-- <div class="avatar avatar-md pd-5 mg-r-10">
                    <img
                      :src="`${$store.state.user.userInfo.avator}`"
                      class="rounded-circle"
                      alt
                    />
                  </div> -->
                  <span class="user-label">
                    {{ $store.state.user.userInfo.fullName }}
                    <img :src="`${myResBaseUrl}v4-assets/svgicon/arrows/outline/direction-down 01.svg`" />
                  </span>
                </a>
                <div class="dropdown-menu dropdown-menu-right tx-13">
                  <div class="avatar avatar-lg mg-b-15">
                    <img
                      :src="`${$store.state.user.userInfo.avator}`"
                      class="rounded-circle"
                      alt
                    />
                  </div>
                  <h6 class="tx-semibold mg-b-5">
                    {{ $store.state.user.userInfo.fullName }}
                  </h6>
                  <p
                    class="mg-b-25 tx-12 tx-color-03 text-truncate"
                    :title="$store.state.user.userInfo.position"
                  >
                    {{ $store.state.user.userInfo.position }}
                  </p>
                  <router-link
                    v-if="
                      !$store.state.app.isMobile &&
                      !(
                        $store.state.app.activeGroup.id == 9241 ||
                        $store.state.app.activeGroup.id == 9249
                      )
                    "
                    :to="{ name: 'settings', params: { mode: '2' } }"
                    class="dropdown-item d-flex align-items-center pd-l-0-f"
                  >
                    <feather
                      type="settings"
                      class="ht-20-f ht-20-f mg-r-5" style="width: 20px; height: 20px;"
                    ></feather
                    >Тохиргоо
                  </router-link>
                  <router-link
                    v-if="
                      !$store.state.app.isMobile &&
                      ($store.state.app.activeGroup.id == 9241 || $store.state.app.activeGroup.id == 9249)
                    "
                    :to="{ name: 'settings', params: { mode: '3' } }"
                    class="dropdown-item d-flex align-items-center pd-l-0-f" 
                  >
                    <feather
                      type="settings"
                      class="ht-20-f ht-20-f mg-r-5" style="width: 20px; height: 20px;"
                    ></feather
                    >Тохиргоо
                  </router-link>
                  <a @click="logout" class="dropdown-item pd-l-0-f mg-t-0-f" role="button">
                    <feather type="log-out" class="ht-20-f ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Гарах
                  </a>
                </div>
              </div>
            </nav>
          </div>

          

        </header>
  <!-- <header
    slot="content-header"
    class="navbar navbar-header"
  >
    <div class="container" @click="closeLevel2()">
      <a @click.stop="showLevel2()" class="burger-menu d-lg-none">
        <feather type="menu" class="wd-20-f ht-20-f"></feather>
      </a>
      <div class="navbar-right">
        <a
          class="burger-menu d-lg-none"
          v-if="$store.state.app.responsiveLayout.level2.show"
        >
          <feather type="arrow-right" class="wd-20-f ht-20-f"></feather>
        </a>
        <a
          @click.stop="$emit('toggle-filter-drawer')"
          class="burger-menu d-lg-none"
          v-if="$route.name == 'lmsCourses'"
        >
          <feather type="filter" class="wd-20-f ht-20-f"></feather>
        </a>
      </div>
    </div>
  </header> -->
</template>

<script>
import { mapActions } from "vuex";

import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";

export default {
  components:{
    locTypeCascader: () => ({
      component: import("@/components/task/edit/components/locTypeCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    headerBarNotification: () => ({
      component: import("@/components/modules/team/headerBarNotification"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    headerBarLocalmail: () => ({
      component: import("@/views/modules/localmail/headerBarMailNotification"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    navbarmode: {
      type: Number,
      default: () => 0
    },
    filterType: {
      type: Number,
      default: () => 0
    },
    filterName: {
      type: String,
      default: () => "Хайх ..."
    },
  },
  data(){
    return{
      showBackdrop: false,
      filterParams:{
        type: -1,
        name: null
      },
      myResBaseUrl: "https://res.gosmart.mn/",
      mustJoinCourses:{
        all: null,
        finished: null,
      },
    }
  },
  created() {
    this.fetchResBase();
  },
  mounted(){
    this.initStat();
  },
  methods: {
    ...mapActions([
      "resetResponsiveLayoutConfig",
      "handleLevel2ResponsiveLayoutConfig",
      "handleLoading",
      "handleLogOut",
      "handleDynamicMenuLoaded"
    ]),
    initStat(){
      request({
        api: { method: "POST", url: "v2/learn/studentHomeData" },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.$emit('on-home-stat', res.data);
          if(this.$store.state.app.activeGroup.id==9241 ||this.$store.state.app.activeGroup.id==9249){
            this.mustJoinCourses = res.data.dashboard.mustJoinCourses;
          }else{
            this.mustJoinCourses = {
              all: res.data.dashboard.stat.pointCount,
              finished: res.data.dashboard.stat.pointCount - res.data.dashboard.stat.notFinishedCount
            };
          }
        }
      });
    },
    searchHandler(){
      if(this.$route.name=='lmsCourses'){
        this.$emit('on-filter', this.filterParams);
      }else{
        this.$router.push({
          name: 'lmsCourses',
          params: { md: 1, cnm: this.filterParams.name, type: this.filterParams.type, d1: "null", d2: "null" }
        });
      }
    },
    searchHandlerFromCascader(e){
      if(this.$route.name=='lmsCourses'){
        this.searchHandler();
      }
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    openSidebar(){

    },
    logout(){
      this.handleLoading({ isLoading: true });
      this.handleLogOut({ store: this.$store }).then((res) => {
        if (res != false) {
          this.handleDynamicMenuLoaded(false);
          this.handleLoading({ isLoading: false });
          this.$router.push({ name: "login" });
        }
      });
    },
    showLevel2() {
      this.showBackdrop= true;
      this.handleLevel2ResponsiveLayoutConfig({
        document: document,
        className: "lms-sidebar-show"
      });

      this.toggleBodyClass("addClass", "lms-sidebar-show");
    },
    closeLevel2() {
      this.showBackdrop= false;
      if (this.$store.state.app.responsiveLayout.level2.show) {
        this.resetResponsiveLayoutConfig(document);
      }

      this.toggleBodyClass("removeClass", "lms-sidebar-show");

      return false;
    }
  }
};
</script>

<style>
.header-backdrop{
  position: fixed; 
  inset: 0px; 
  background: rgba(0,0,0,0.3); 
  z-index: 6; 
  visibility: visible; 
  opacity: 1;
}
</style>
